var map = {
	"./gallery_00.jpg": 1878,
	"./gallery_01.jpg": 1879,
	"./gallery_02.jpg": 1880,
	"./gallery_03.jpg": 1881,
	"./gallery_04.jpg": 1882,
	"./gallery_05.jpg": 1883,
	"./gallery_06.jpg": 1884,
	"./gallery_07.jpg": 1885,
	"./gallery_08.jpg": 1886,
	"./gallery_09.jpg": 1887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1877;